import * as types from './types';

const INITIAL_STATE = {
  importSite: {
    Data: [],
    Errors: [],
  },
  importSiteErrors: undefined,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.IMPORTSITE_IMPORT:
    case types.IMPORTSITE_ERROR:
      return { ...state, importSite: action.payload.data };
    case types.IMPORTSITE_CLEAR_ERROR:
      return { ...state, importSite: { Errors: undefined } };
    case types.IMPORTSITE_CLEAR_DATA:
      return { ...state, importSite: { Data: undefined } };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/importsite/state/reducer.js